import { useEffect } from 'react';
import { useReduxState } from 'hooks';
import { Alert } from 'components/common';
import { useHomePageSettingsContext, useHomePageSettingsDispatch } from '.';

import type { ModuleInSettings } from './HomePageSettingsModules';

type Errors = { [key: string]: boolean };

interface Props {
  index: number;
  module: ModuleInSettings;
}

const HomePageSettingsModulesCheckErrors = ({ index, module }: Props) => {
  const state = useHomePageSettingsContext();

  const dispatch = useHomePageSettingsDispatch();

  const { messages } = useReduxState();

  const errors = {} as Errors;

  useEffect(() => {
    return () => dispatch({ type: 'updateErrors', value: { [index]: false } });
  }, []);

  useEffect(() => {
    const hasErrors = Object.keys(errors).length;
    const errorsInState = state.errors[index];
    if (hasErrors && !errorsInState) {
      dispatch({ type: 'updateErrors', value: { [index]: true } });
    } else if (!hasErrors && errorsInState) {
      dispatch({ type: 'updateErrors', value: { [index]: false } });
    }
  }, [errors]);

  if (module.type === 'courses-category') {
    if (!module.categories?.length)
      errors[messages.homePageModuleErrorsMissingCategory] = true;
  } else if (module.type === 'courses-selected') {
    const hasCourses = Boolean(module.courses?.length);
    if (!hasCourses) errors[messages.homePageModuleErrorsMissingCourse] = true;
  } else if (module.type === 'paths-selected') {
    const hasPaths = Boolean(module.paths?.length);
    if (!hasPaths) errors[messages.homePageModuleErrorsMissingPath] = true;
  } else if (module.type === 'calendar-events-selected') {
    const hasEvents = Boolean(module.events?.length);
    if (!hasEvents) {
      errors[messages.homePageModuleErrorsMissingCalendarEvent] = true;
    }
  }

  return errors && Object.keys(errors).length ? (
    <div className="errors">
      {Object.keys(errors).map((error, i) => (
        <Alert key={i} type="error-light" text={error} />
      ))}

      <style jsx>{`
        .errors {
          display: flex;
          flex-direction: column;
          gap: 10px;
          margin-top: 10px;
        }
      `}</style>
    </div>
  ) : null;
};

export default HomePageSettingsModulesCheckErrors;
